export const generateGiftboxId = ()=>`giftbox_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
